import $ from "jquery";
import "slick-carousel";

// Product Carousels
export const initProductCarousels = () => {
    $(".product-carousel").each(function () {
        $(this)
            .find(".product-carousel__slider")
            .slick({
                dots: false,
                arrows: true,
                infinite: true,
                autoplay: false,
                speed: 300,
                slidesToShow: 4,
                slidesToScroll: 1,
                variableWidth: true,
                prevArrow: $(this).find(".product-carousel__slider__arrow-prev"),
                nextArrow: $(this).find(".product-carousel__slider__arrow-next"),
                responsive: [
                   
                    {
                        breakpoint: 1100,
                        settings: {
                            slidesToShow: 2,
                            variableWidth: false,
                        },
                    },
                    {
                        breakpoint: 750,
                        settings: {
                            slidesToShow: 1,
                            arrows: false,
                            dots: true,
                            variableWidth: false,
                        },
                    }                ],
            });
    });
}

// Related Product Carousel
export const initRelatedProductCarousels = () => {
    $(".related-products").each(function () {
        $(this)
            .find(".product-carousel__slider")
            .slick({
                dots: false,
                arrows: true,
                infinite: true,
                autoplay: false,
                speed: 300,
                slidesToShow: 4,
                slidesToScroll: 1,
                variableWidth: true,
                prevArrow: $(this).find(".product-carousel__slider__arrow-prev"),
                nextArrow: $(this).find(".product-carousel__slider__arrow-next"),
                responsive: [
                 
                    {
                        breakpoint: 110,
                        settings: {
                            slidesToShow: 2,
                            variableWidth: false,
                        },
                    },
                    {
                        breakpoint: 750,
                        settings: {
                            slidesToShow: 1,
                            arrows: false,
                            dots: true,
                            variableWidth: false,
                        },
                    }
                   
                ]
            })
    });
}
